import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ValidationService } from 'src/app/services/validation.service';
import { SuccessComponent } from './success/success.component';
import { MatDialog } from '@angular/material/dialog';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ThemeService } from 'src/app/services/theme.service';
@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss'],
})
export class ResetpasswordComponent implements OnInit {
  confirmshowPassword: boolean = true;
  showPassword: boolean = true;
  token: any;
  pswrdMatched = true;
  success = false;
  hide = true;
  pswrdObj: any = [];
  pswrdForm: FormGroup | any;
  validationMessages: any;
  msg = '';
  clicked: boolean = false;
  isTokenError: boolean = false;
  lastSubmittedPassword: string = '';
  isInIframe: boolean;
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private userService: UserService,
    private matdialog: MatDialog,
    private vs: ValidationService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private themeService: ThemeService,
  ) {
    this.isInIframe = this.themeService.isInIframe();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
    });
    this.pswrdForm = this.fb.group({
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(25),
          Validators.pattern('^(?=.*[A-Z])(?=.*[!@#$%^&_+=]).*$'),
        ]),
      ],
      // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9#%@&*._$!()]+$')])],
      confirmpassword: ['', Validators.required],
    });
    this.validationMessages = this.vs.account_validation_messages;
  }
  areEqual(event: any) {
    const password = this.pswrdForm.value.password;
    const confirmPassword = this.pswrdForm.value.confirmpassword;
    
    // Only show error if confirmpassword has content and doesn't match
    if (confirmPassword === '') {
      this.pswrdMatched = true;
    } else if (password === confirmPassword) {
      this.pswrdMatched = true;
    } else {
      this.pswrdMatched = false;
    }
  }
  passwordChanged(event: any) {
    const currentPassword = this.pswrdForm.value.password;
    // Only reset if not a token error and password is different from what was submitted
    if (!this.isTokenError && currentPassword !== this.lastSubmittedPassword) {
      this.msg = '';
      this.clicked = false;
      this.success = false;
    }
  }
  confirmPasswordChanged(event: any) {
    const currentPassword = this.pswrdForm.value.password;
    // Only reset if not a token error and password is different from what was submitted
    if (!this.isTokenError && currentPassword !== this.lastSubmittedPassword) {
      this.msg = '';
      this.clicked = false;
      this.success = false;
    }
    this.areEqual(event);
  }
  submitForm(event: any) {
    if (event.keyCode === 13) {
      this.resetPswrd();
    }
  }
  resetPswrd() {
    if (this.pswrdForm.valid) {
      this.clicked = true;
      const pswrd = this.pswrdForm.value.password.trim();
      const re_pswrd = this.pswrdForm.value.confirmpassword.trim();
      if (pswrd != re_pswrd) {
        this.pswrdMatched = false;
        return;
      }

      // Store the submitted password to compare later
      this.lastSubmittedPassword = pswrd;

      this.recaptchaV3Service
        .execute('importantAction')
        .subscribe((token: string) => {
          const reCAPTCHAToken = token;
          this.pswrdObj = { password: pswrd, reCAPTCHAToken: reCAPTCHAToken };
          if (this.token) {
            this.userService.resetPswrd(this.token, this.pswrdObj).subscribe(
              (res: any) => {
                if (res.Msg != 'Failed captcha verification') {
                  this.msg = 'Your password is reset successfully';
                  this.success = true;
                  this.OpenPopup();
                }
              },
              (err) => {
                if (err?.status === 500) {
                  this.msg = 'An error occurred during processing and ingestion of the request. Please try after sometime.';
                  this.isTokenError = false;
                  this.clicked = false;
                } else {
                  const errorMsg = err?.error?.Msg || err?.error || 'Password reset token is invalid or has expired.';
                  this.msg = errorMsg;
                  
                  // Check if this is a token-related error (permanent disable)
                  const isTokenRelatedError = errorMsg.toLowerCase().includes('token');
                  this.isTokenError = isTokenRelatedError;
                  
                  // Keep button disabled for all errors - will only re-enable when user changes password
                  // (handled in passwordChanged/confirmPasswordChanged methods)
                }
                this.success = false;
              },
            );
          }
        });
    }
  }
  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  public toggleconfirmPasswordVisibility(): void {
    this.confirmshowPassword = !this.confirmshowPassword;
  }

  OpenPopup() {
    this.matdialog.open(SuccessComponent, { 
      width: '50%',
      disableClose: true,
      backdropClass: 'backdropBackground'
    });
  }
  get sign() {
    return this.pswrdForm.controls;
  }
}
